import { Grid, Typography } from '@mui/material'
import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel'

export const DirRootDetails = ({ folder }) => {
  if (!folder) {
    return <></>
  }
  if (folder.exist === false) {
    return (
      <div
        style={{
          width: '100%',
          padding: '10px 0px 10px 10px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <CancelIcon style={{ color: '#AD0707' }} />
        <Typography
          style={{
            paddingLeft: 5,
            fontWeight: 'bold',
            color: '#4B4952'
          }}
        >
          No existe la carpeta de sistema
        </Typography>
      </div>
    )
  }
  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }
  if (folder.directory[0]) {
    return (
      <Grid container xs={12} style={{ padding: 10 }}>
        <Grid item xs={4}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#485450'
            }}
          >
            Creado por:
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#6e7a76'
            }}
          >
            {folder.directory[0].creationUser}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#485450'
            }}
          >
            Fecha de creación:
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#6e7a76'
            }}
          >
            {formatDate(folder.directory[0].creationDate)}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#485450'
            }}
          >
            Nombre:
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#6e7a76'
            }}
          >
            {folder.directory[0].name}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#485450'
            }}
          >
            Tamaño:
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#6e7a76'
            }}
          >
            {folder.directory[0].storageData?.size}
          </Typography>
        </Grid>
      </Grid>
    )
  }
}
